// extracted by mini-css-extract-plugin
export default {"card":"home_card__JgJjP","cardCell":"home_cardCell__k2VV9","positionTop":"home_positionTop__oqMhe"};